// extracted by mini-css-extract-plugin
var _1 = "fiTAIzy3aI";
var _2 = "Wr2fOlS1BS";
var _3 = "NC6hUUtghU";
var _4 = "mNkzVTEtkb";
var _5 = "LWtkdiYpYw";
var _6 = "y5T2HgE3eM";
var _7 = "ElVmwrRIAa";
var _8 = "AE7RQErQSP";
var _9 = "WZGnUsAPoA";
var _a = "SKK4yTkTJW";
export { _1 as "accountLink", _2 as "icon", _3 as "isActive", _4 as "label", _5 as "link", _6 as "localeLink", _7 as "logo", _8 as "root", _9 as "spacer", _a as "userName" }
